import { DotsIcon } from 'components/Icons';
import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


const ThreeDotMenu = ({ customClass, handleDelete, handleReport, handleCopy, handleUnlike }) => {
    const { t } = useTranslation();


    const items = {
        delete: {
            name: 'Delete',
            id: 'delete',
            clickFunction: handleDelete
        },
        report: {
            name: 'Report',
            id: 'report',
            clickFunction: handleReport
        },
        copy: {
            name: 'Copy',
            id: 'copy',
            clickFunction: handleCopy,
        },
        unlike: {
            name: 'Unlike',
            id: 'unlike',
            clickFunction: handleUnlike,
        }
    }


    const MoreMenuBtn = React.forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <DotsIcon fill="#fff" width={10} height={5} style={{ transform: 'rotate(90deg)' }}>
                {children}
            </DotsIcon>
        </div >
    ));

    return (
        <Dropdown alignLeft={true} className={customClass}>
            <Dropdown.Toggle as={MoreMenuBtn}></Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    Object.values(items).map((item, index) => {
                        return <Dropdown.Item
                            key={index}
                            onClick={() => item.clickFunction(item.id)}>
                            {item.name}
                        </Dropdown.Item>
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default ThreeDotMenu;
